import React, { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';

import { useCustomer } from '~/techstyle-shared/react-accounts';
import { useProductDetailContext } from '~/techstyle-shared/react-components';

import { useAssortmentTest } from '../../context/AssortmentTestContext';
import { useSunbitModal } from '../../utils/useSunbitModal';
import ProductDetailCTAs from '../ProductDetailCTAs';
import SunbitModal from '../SunbitModal';
import WearItWith from '../WearItWith';

function ProductCTA({
  isLocked,
  isPlatinumExclusive,
  showWearItWith,
  tier,
  wearItWithProductIds,
  isAfterpayEnabled,
  isKlarnaEnabled,
  isPDP = false,
}) {
  const { isAssortmentTestProductDisabled: mainProductDisabled, isBundle } =
    useProductDetailContext();
  const { disabledBundleItems } = useAssortmentTest();

  const customer = useCustomer();

  const firstName = customer?.firstName || '';

  const {
    showModalIfEligible: showSunbitModalIfEligible,
    isModalOpen: isSunbitModalOpen,
    closeModal: closeSunbitModal,
    eligibleVariant,
    brandedCreditCardInfo,
  } = useSunbitModal();

  const handleSuccessfulAddToCart = useCallback(() => {
    showSunbitModalIfEligible();
  }, [showSunbitModalIfEligible]);

  // Check if any outfit/bundle item is disabled by assortment tests
  const isAssortmentTestProductDisabled = useMemo(() => {
    // For bundles/outfits, only check the individual items, not the bundle container itself
    if (isBundle) {
      return disabledBundleItems.size > 0;
    }

    // For single products, check if the product itself is disabled
    return mainProductDisabled;
  }, [mainProductDisabled, isBundle, disabledBundleItems]);

  // Get the offer amount and CTA URL from brandedCreditCardInfo
  const offerAmount =
    brandedCreditCardInfo?.preapprovedAmount?.toString() || '';
  const ctaUrl = brandedCreditCardInfo?.invitationUrl || '';
  const expiryDate = brandedCreditCardInfo?.dateExpires || '';

  if (showWearItWith) {
    return (
      <>
        <WearItWith wearItWithProductIds={wearItWithProductIds}>
          <ProductDetailCTAs
            onSuccessfulAddToCart={handleSuccessfulAddToCart}
            isLocked={isLocked}
            isPlatinumExclusive={isPlatinumExclusive}
            tier={tier}
            isAfterpayEnabled={isAfterpayEnabled}
            isKlarnaEnabled={isKlarnaEnabled}
            isPDP={isPDP}
            isAssortmentTestProductDisabled={isAssortmentTestProductDisabled}
          />
        </WearItWith>
        {isSunbitModalOpen && (
          <SunbitModal
            isOpen={isSunbitModalOpen}
            onClose={closeSunbitModal}
            eligibleVariant={eligibleVariant}
            firstName={firstName}
            offerAmount={offerAmount}
            ctaUrl={ctaUrl}
            expiryDate={expiryDate}
          />
        )}
      </>
    );
  }
  return (
    <>
      <ProductDetailCTAs
        onSuccessfulAddToCart={handleSuccessfulAddToCart}
        isLocked={isLocked}
        isPlatinumExclusive={isPlatinumExclusive}
        tier={tier}
        isAfterpayEnabled={isAfterpayEnabled}
        isKlarnaEnabled={isKlarnaEnabled}
        isPDP={isPDP}
        isAssortmentTestProductDisabled={isAssortmentTestProductDisabled}
      />
      {isSunbitModalOpen && (
        <SunbitModal
          isOpen={isSunbitModalOpen}
          onClose={closeSunbitModal}
          eligibleVariant={eligibleVariant}
          firstName={firstName}
          offerAmount={offerAmount}
          ctaUrl={ctaUrl}
          expiryDate={expiryDate}
        />
      )}
    </>
  );
}

ProductCTA.propTypes = {
  isAfterpayEnabled: PropTypes.bool,
  isKlarnaEnabled: PropTypes.bool,
  isLocked: PropTypes.bool,
  isPDP: PropTypes.bool,
  isPlatinumExclusive: PropTypes.bool,
  showWearItWith: PropTypes.bool,
  tier: PropTypes.object,
  wearItWithProductIds: PropTypes.array,
};

export default ProductCTA;
